import { SWRConfiguration } from 'swr'
import { Payout, getPayouts } from '@/services/api/payout'
import useAuth from '@/services/hooks/useAuth'
import useApi from '../useApiV2'

const usePayouts = (config?: SWRConfiguration) => {
  const { user } = useAuth()

  const { data, ...rest } = useApi<Payout[]>({
    key: user ? `${user.id}-payouts` : false,
    request: getPayouts,
    config,
  })

  return { payouts: data, ...rest }
}

export default usePayouts
